import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { rowsPerPage, pagination } from '../../_Models/pagination';
import { MatDialog } from '@angular/material/dialog';
import { OfferstatusDialogComponent } from 'src/app/containers/timeline4/offer/offerstatus-dialog/offerstatus-dialog.component';


@Component({
    selector: 'mt-table-default',
    templateUrl: 'table-default.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableDefaultComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() rows: any = [];
  @Input() headers: any = [];
  @Input() limit: number = rowsPerPage;
  @Input() offset: number = 0;
  @Input() count: number = 0;
  @Input() clearSelection: boolean = false;
  @Input() loading: boolean = false;
  @Input() class: string;
  @Input() tableButtons: any = [];
  @Input() offer: any = [];
  
  @Input() tableHeader: {
    title: "",
    subTitle: ""
  };
  // features like search, download, selectable, dlickEnabled
  @Input() features: any = {
    download: false,
    search: false,
    selectable: false,
    extPage: false,
    dlickEnabled: false,
    isPipeSaperate: false, 
    noScroll:false
  };

  @Output() onSelection = new EventEmitter<any>();
  @Output() rowClick = new EventEmitter<any>();
  @Output() rowDblclick = new EventEmitter<any>();
  @Output() colClick = new EventEmitter<any>();
  @Output() onSort = new EventEmitter<any>();
  @Output() onPage = new EventEmitter<any>();
  @Output() onDownload = new EventEmitter<any>();
  @Output() onSearch = new EventEmitter<any>();
  @Output() onTableButtonAction = new EventEmitter<any>();
  @Output() rowButtonClick = new EventEmitter<any>();
  @Input() offerDetailsId : any;
  disablebtn: boolean = false;

  @Input() sendLimit: boolean = false;

  @ViewChild(MatPaginator) matPaginator: MatPaginator;
  @ViewChild(MatSort) matSort: MatSort;

  tableFeatures: any = {};
  // paginator: MatPaginator;
  // @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
  //   this.paginator = mp;
  //   this.setDataSourceAttributes();
  // }
  // sort: MatSort;

  // @ViewChild(MatSort) set matSort(ms: MatSort) {
  //   this.sort = ms;
  //   this.setDataSourceAttributes();
  // }

  selection = new SelectionModel<any>(true, []);
  rowsData: MatTableDataSource<any>;

  selectedData: any = [];
  displayedColumns = [];
  selectedRowIndex: any;
  notFoundMsg: string = null;
  pageLengths: any = pagination;
  postObj: any = {
    limit: this.limit,
    offset: 0
  };
  searchStr: string | null;
  selectedDues: any = [];
  touchCount: number = 0;
  newColumns = [
    {
      name: 'Status',
      prop: 'paymentStatus',
      pipe: '',
    },
    {
      name: 'Action',
      prop: 'btn',
      pipe: '',
    }
  ];
  showAlert: boolean;
  offerDetailId: any;

  constructor(private cdref: ChangeDetectorRef,  public dialog: MatDialog) {}

  ngOnInit() {
    this.clearSelection = false;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  openDialog(element): void {
    let dueId = window.location.href.split('/')[4];
    const dialogRef = this.dialog.open(OfferstatusDialogComponent, {
      data: [element,dueId, this.offerDetailsId],
      width: '650px',
      height: '450px'
    });
  }


  ngOnChanges(changes) {
    this.tableFeatures = Object.assign({}, this.features);
    let extraCols = [];
    if (this.tableFeatures.selectable) extraCols = ['select'];
    if (this.headers && this.headers.length > 0) {
      this.displayedColumns = this.headers.map((col: any) => (col.name! !== '' ? col.name : 'total'));
      this.displayedColumns = [...extraCols, ...this.displayedColumns];
    }
    this.selection.clear();
    this.rowsData = new MatTableDataSource(this.rows);
    this.notFoundMsg = null;
    // set paginator after page loads
    setTimeout(() => {
      this.rowsData.paginator = this.matPaginator;
    }, 50);
    // if no data found
    if (this.rows && this.rows.length < 1) {
      this.notFoundMsg = 'No Records found!';
    }
    if (this.clearSelection) {
      this.selection.clear();
      this.clearSelection = false;
    }
    if (this.rows && this.rows.length > 0) {
      this.offerDetailId = this.offer["OfferMap.OfferDetail.id"]
    }
  }

  /**
   * Set the sort after the view init since this component will
   * be able to query its view for the initialized sort.
   */
  ngAfterViewInit() {
    if (this.rows && this.rows.length > 0) {
      this.rowsData.sort = this.matSort;

      setTimeout(() => {
        this.rowsData.paginator = this.matPaginator;
      }, 50);
      // If the user changes the sort order, reset back to the first page.
      // this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 1);
    }
  }

  // to get row class name
  getRowClass(row: any) {
    if (row.actionClassName) {
      return row.actionClassName;
    }
    return '';
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.rows && this.rows.length > 0) {
      const numSelected = this.selection.selected.length;
      const numRows = this.rowsData.data.length;
      if (numSelected !== numRows) this.getSelected(this.selection);
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.rows && this.rows.length > 0) {
      this.isAllSelected() ? this.selection.clear() : this.rowsData.data.forEach(row => this.selection.select(row));
      this.getSelected(this.selection);
    }
  }

  /* updated through the event emmiter*/
  rowToggle(row) {
    this.selection.toggle(row);
    this.getSelected(this.selection);
  }


  onRowButtonAction(btn, row) {
    this.rowButtonClick.emit({btn, row});
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  getSelected($event: any) {
    // if ($event && $event.selected && $event.selected.length > 0) {
    this.selectedDues = $event.selected.map((obj: any) => {
      return obj && obj._source ? obj._source.id : obj.id;
    });
    // }
    this.onSelection.emit($event.selected);
  }

  // to highlight the row
  highlightRow(row: any) {
    this.selectedRowIndex = row.id;
  }

  // for pagination
  onPaginate($event: any) {
    const { offset, limit } = $event;
    this.postObj = {
      limit,
      offset
    };
    this.onPage.emit(this.postObj);
  }

  // on sorting
  onSorting($event: any) {
    const { direction, active } = $event;
    const index = this.headers.findIndex(obj => obj.name === active);
    if (this.headers[index].sortable && ['desc', 'asc'].includes(direction)) {
      const sortProp = this.headers[index].prop;
      this.postObj = {
        orderin: direction,
        orderby: sortProp,
        offset: 0
      };
      this.onSort.emit(this.postObj);
    }
  }

  onClick(row: any) {
    if (this.tableFeatures.dlickEnabled) {
      if (this.touchCount == 0) {
        this.touchCount = new Date().getTime();
      } else {
        if (new Date().getTime() - this.touchCount < 800) {
          this.rowDblclick.emit(row);
          this.touchCount = 0;
        } else {
          this.touchCount = new Date().getTime();
        }
      }
    } else this.rowClick.emit(row);
  }

  onDblclick(row: any) {
    this.rowDblclick.emit(row);
  }

  onColClick(column: string, row: any, index?: number) {  
    this.colClick.emit({ column, row, index });
  }

  downloadRecords() {
    this.disablebtn = true;
    setTimeout(() => {
      this.disablebtn = false;
      this.loading = false 
    }, 10000);
    this.onDownload.emit();
  }
  searchRecords($event: any) {
    this.onSearch.emit($event);
  }

  onButtonAction(value) {
    this.onTableButtonAction.emit(value);
  }

  isString(value: any) {
    if (typeof value === 'string' || typeof value === 'number') {
      return true;
    } else {
      return false;
    }
  }
}
